import { BaseEventCommand } from './base-event-command.model';

export class CreateEventCommand extends BaseEventCommand { }
